
<ng-template #contentTemplate>
      <div>
        <p [innerHTML]="message"></p>
      </div>
</ng-template>

<div class="meli-card" [ngClass]="{'selected':itemselected}" nz-tooltip
    [nzTooltipTitle]="itemselected ? ('meli.item.hasLinkedProducts'|translateTA) : ''"
    nzTooltipPlacement="top" nzTooltipColor="#b71c1c">
    <nz-spin [nzSpinning]="loading" nzSize="large" class="card-spin">
    <div class="meli-card-header">
        <div class="meli-card-heading">
            <div class="meli-card-title">{{melidata['title']}}</div>
            <div class="meli-card-subtitle">{{melidata['id']}}</div>
        </div>
        <button
            nz-button
            nz-popover
            nzShape="circle"
            *ngIf="showVariationAlert"
            [nzPopoverTitle]="'meli.download.variation.error'|translateTA"
            [nzPopoverContent]="contentTemplate"
            nzPopoverPlacement="topRight"
        >
            <nz-icon nzType="warning" nzTheme="twotone" nzTwotoneColor="red"></nz-icon>
        </button>
    </div>
    <div class="meli-card-content">
        <div class="content">
            <div class="foto">
                <img [src]="melidata['thumbnail']" class="responsive">
            </div>
            <div class="dados">
                <div class="sumario">
                    <ul class="left">
                        <li><b>{{'meli.form.condition'|translateTA}}:</b> {{melidata["condition"]}}</li>
                        <li><b>{{'meli.item.type'|translateTA}}:</b> {{melidata['listing_type_id']}}</li>
                        <li><b>{{'meli.form.quantity'|translateTA}}:</b> {{melidata["available_quantity"]}}</li>
                        <li><b>{{'meli.form.price'|translateTA}}:</b> {{melidata["price"] |  currency:'BRL':'symbol-narrow'}}</li>
                        <li *ngIf="melidata['shipping'] && melidata['shipping']['mode']"><b>{{'meli.item.delivery'|translateTA}}:</b> {{melidata["shipping"]['mode']}} </li>
                        <li *ngIf="melidata['shipping'] && melidata['shipping']['logistic_type']"><b>{{'meli.item.logistics'|translateTA}}:</b> {{melidata["shipping"]['logistic_type']}} </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="meli-card-actions">
        <div class="actions-buttons" >
            <button nz-button (click)="importar($event)">{{'meli.item.import'|translateTA}}</button>
            <button nz-button nzType="primary" (click)="openDetails($event)">{{'meli.item.details'|translateTA}}</button>
        </div>
    </div>
    </nz-spin>
</div>
